<template>
  <div>
    <div class="row g-3 mb-3">
      <div class="col-sm-12 col-xl-6">
      <div class="form-card h-100 p-4">
        <h6 class="mb-4">Add Sector</h6>
        <form @submit.prevent="onSubmit">
          <div class="form-floating mb-3">
            <input
              type="text"
              v-model="form.name"
              name="name"
              class="form-control"
              id="name"
              placeholder="Sector Name"
            />
            <label for="name">Name</label>
          </div>
          <div class="form-floating mb-3">
            <button :disabled="v$.form.$invalid" type="submit" @click="addNewSector()" class="btn btn-primary">
              Submit
            </button>
          </div>
        </form>
      </div>
      </div>
      <div class="col-sm-12 col-xl-6">
        <div class="analysis-preview-card rounded h-100 p-4">
          <p class="analysis-preview-kicker mb-2">Sector Workspace</p>
          <h5 class="mb-2">Review allocation, performance, and risk by sector.</h5>
          <p class="text-muted mb-4">
            Open the sector analysis dashboard to inspect overweight positions, weak sectors, and stock-level exit signals.
          </p>
          <router-link to="/sector/summary" class="btn btn-dark">
            Open Sector Analysis
          </router-link>
        </div>
      </div>
    </div>
    <ReportTable title="Sector" :fields='sectorFields' :data ='sectorList'/>
  </div>
</template>
  
  <script>
  import useVuelidate from "@vuelidate/core";
  import { required } from "@vuelidate/validators";
  import { useAlertStore } from '@/stores';
  import ReportTable from '@/components/Report/Table.ce.vue';
  import { fetchWrapper } from '@/helpers';

  export default {
    name: "add-sector",
    components: {
      ReportTable
    },
    setup() {
      return { 
        v$: useVuelidate(),
        alertStore$: useAlertStore(),
       };
    },
    data() {
      return {
        form: {
          name: "",
        },
        sectorList: [],
        sectorFields: 
        {
          'sector_id' : {
            'text' : 'Sector Id',
            'type' : 'number',
          },
          'name' : {
            'text' : 'Name',
            'type' : 'text', 
          },
        }
      };
    },
    validations() {
      return {
        form: {
          name: { required },
        },
      };
    },
    methods: {
      addNewSector() {
        try {
          fetchWrapper.post('api/sector/add-new', this.form)
            .then((response) => {
                if(response.data.success){
                  this.alertStore$.success('New Sector add successfully.');   
                  this.sectorList.push(response.data.data);
                } else {
                  this.alertStore$.error(response.message);
                }
            })
          } catch (error) {
              console.log(error);
          }
      },
      getSector() {
        fetchWrapper.post('api/sector')
          .then((response) => {
            this.sectorList = response.data;
        })
      },
    },
    mounted() {
        this.getSector();
    },
  };
  </script>

<style scoped>
.form-card {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
}

.analysis-preview-card {
  border: 1px solid var(--border);
  background: var(--primary-tint);
  border-radius: 12px;
}

.analysis-preview-kicker {
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--text-muted);
}
</style>
